/**
 * Normalize BFF language options: Hub expects { value, label }.
 * Older string[] responses still work during rollout.
 */
export function normalizeLanguageOptions(raw) {
    if (!Array.isArray(raw)) return [];
    return raw.map((opt) => {
        if (opt && typeof opt === "object" && opt.value != null) {
            return {
                value: String(opt.value),
                label: String(opt.label ?? opt.value),
            };
        }
        const value = String(opt ?? "");
        return { value, label: value };
    });
}

/** Resolve English (or BFF) label for an Airtable Language value. */
export function contactLanguageLabel(value, options = []) {
    const trimmed = String(value ?? "").trim();
    if (!trimmed) return "no data";
    const hit = normalizeLanguageOptions(options).find(
        (opt) => opt.value === trimmed,
    );
    return hit?.label || trimmed;
}
